import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api';
import { timesheetEndpoints } from '@/lib/api/endpoints';
import { timesheetKeys } from '@/lib/queryKeys';
import type { TimesheetDayEntry, UpdateTimesheetEntryDto } from '@/types/timesheet';

/** Edit a single time entry (break/type/notes) from the day drill-down. */
export function useUpdateTimesheetEntry() {
  const queryClient = useQueryClient();
  return useApiMutation<TimesheetDayEntry, { id: string; dto: UpdateTimesheetEntryDto }>({
    mutationFn: ({ id, dto }) =>
      apiPatch<TimesheetDayEntry, UpdateTimesheetEntryDto>(
        operationsClient,
        timesheetEndpoints.entryDetail(id),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: timesheetKeys.all() });
      toast.success('Time entry updated');
    },
  });
}
